module.exports = __webpack_public_path__ + "img/building10.4529edc2.jpg";